import { defineMessages } from 'react-intl'

const messages = defineMessages({
  moreRecentDataAvail: {
    id: 'PanelRowCointaner.moreRecentDataAvail',
    description: 'Texto para indicar que hay datos más recientes',
    defaultMessage: 'Datos de región disponibles hasta {mostRecentYear}'
  },
  moreIndicatorDetail: {
    id: 'PanelRowCointaner.moreIndicatorDetail',
    description: 'Texto para indicar más detalle en indicador',
    defaultMessage: 'Ver indicador en detalle'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Charts/PanelRow/PanelRowContainer/messages.js